import { useRouter } from 'next/router';
import { LinkProps } from 'next/link';
import { isProduction } from '@/utils/helpers';
import { checkRoute } from '@/components/CustomLink/CustomLink.helpers';
import useScreenSize from '@/hooks/useScreenSize';

export function useCustomPush() {
  const router = useRouter();
  const { isLarge } = useScreenSize();

  return function customPush(href: LinkProps['href']) {
    const { isInternal, hrefString } = checkRoute(href, { isDesktop: isLarge });

    if (!isProduction()) {
      return router.push(href);
    }

    if (isInternal) {
      router.push(href);
    } else {
      window.location.href = hrefString;
    }
  };
}
